module.exports = "/images/role-it-developer-icon.svg?6c9a332a0691fe8f7d9ac33d4bede960";